import "./Pagination.scss";

import React from "react";
import ReactPaginate from "react-paginate";
import cx from "clsx";

export interface PaginationProps {
  current?: number;
  limit?: number;
  total: number;
  range?: number;
  step?: number;
  onChange?(page: number): void;
}

const Pagination = ({ current = 1, total = 0, limit = 15, range = 3, step = 3, onChange = () => {} }: PaginationProps) => {
  const classes = cx("pagination", "pagination-rounded", "justify-content-end");

  const customClasses = {
    pageClassName: "page-item",
    pageLinkClassName: "page-link",
    previousClassName: "page-item",
    previousLinkClassName: "page-link",
    nextClassName: "page-item",
    nextLinkClassName: "page-link",
    activeClassName: "active",
    breakClassName: "page-item",
    breakLinkClassName: "page-link"
  };

  const previousLabel = <i className="mdi mdi-chevron-left" />;
  const nextLabel = <i className="mdi mdi-chevron-right" />;

  return (
    <ReactPaginate
      onPageChange={({ selected }) => onChange(selected + 1)}
      forcePage={current - 1}
      pageCount={Math.ceil(total / limit)}
      pageRangeDisplayed={step}
      marginPagesDisplayed={range}
      containerClassName={classes}
      {...{ previousLabel, nextLabel }}
      {...customClasses}
    />
  );
};

export default Pagination;
